// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Data Sources Area
export class AreaDataSources {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Retrieves a single source by its id
     * @param from - Remote version to fetch from
     * @returns Single data source
     */
    async getDataSourceById(from, sourceId) {
        return this.dataCore.designSystemSource(from.designSystemId, sourceId);
    }
    async getDataSources(from) {
        return this.dataCore.designSystemSources(from.designSystemId);
    }
    /** Retrieves all figma frames structures
     * @param from - Remote version to fetch from
     * @returns All data sources in the specified version
     */
    async getFigmaNodeStructures(from) {
        return this.dataCore.getFigmaNodeStructures(from.designSystemId);
    }
    /** Retrieves figma frame structure detail
     * @param from - Remote version to fetch from
     * @returns All data sources in the specified version
     */
    async getFigmaNodeStructureDetail(from) {
        return this.dataCore.getFigmaNodeStructureDetail(from.designSystemId, from.figmaStructureId);
    }
    async getStorybookEntries(from) {
        return this.dataCore.getStorybookEntries(from.designSystemId, from.versionId);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Create/Update
    async linkFigmaSource(from, url, options) {
        return this.dataCore.linkFigmaSource(from.designSystemId, from.brandId, url, options);
    }
    async updateFigmaSource(from, sourceId, options) {
        return this.dataCore.updateFigmaSource(from.designSystemId, sourceId, options);
    }
    async linkStorybookSource(from, payload) {
        return this.dataCore.linkStorybookSource(from.designSystemId, payload);
    }
    async updateStorybookSource(from, payload) {
        return this.dataCore.updateStorybookSource(from.designSystemId, from.versionId, payload);
    }
    async replaceStorybookStory(from, storyId, payload) {
        return this.dataCore.replaceStorybookStory(from.designSystemId, from.versionId, storyId, payload);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Delete
    async deleteFigmaSource(from, sourceId) {
        return this.dataCore.deleteFigmaSource(from.designSystemId, sourceId);
    }
}
